import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import RoomTwoToneIcon from '@material-ui/icons/RoomTwoTone'

const useStyles = makeStyles((theme) => {
    return {
        mapMarker: {
            color: theme.palette.primary.main,
            transform: 'translate(-100%, -80%)',
            width: '2rem',
            '&:hover': {
                color: theme.palette.primary.light,
            },
            '&:focus': {
                color: theme.palette.primary.light,
            },
            '& svg': {
                fontSize: ({ isLarge }) => (isLarge ? '4rem' : '2.5rem'),
                '& path:first-of-type': {
                    opacity: 1,
                },
                '& path:last-of-type': {
                    fill: theme.palette.primary.dark
                },
                '& circle': {
                    fill: theme.palette.primary.dark
                },
            }
        },
    }
})

export default function MarkerWithIcon(props) {
    const classes = useStyles({ isLarge: props.isLarge })
    const { handleClick } = props
    return (
        <div
            className={classes.mapMarker}
            onClick={handleClick}
        >
            <RoomTwoToneIcon />
        </div>
    )
}
